
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/regulation/privacy-policy",
      function () {
        return require("private-next-pages/regulation/privacy-policy.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/regulation/privacy-policy"])
      });
    }
  